import { faCheck, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { STATUS_ENUM } from '../components/agv-status/status-enum';

export const PACKAGING_TYPE = {
  VRAC: 'VRAC',
  COFFRE: 'Coffre à sacs',
  SAC: 'SAC',
};

export const BL_STATUS = {
  PLANNED: 'PLANNED',
  STARTED: 'STARTED',
  PARTIALLY_DELIVERED: 'PARTIALLY_DELIVERED',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  properties: {
    PLANNED: {
      display_name: 'Planifiée',
      color: '#878c92',
      color_class: 'ok',
      style: STATUS_ENUM.NEUTRAL,
    },
    STARTED: {
      display_name: 'Livraison en cours',
      color: '#079992',
      color_class: 'started',
      style: STATUS_ENUM.INFO,
    },
    PARTIALLY_DELIVERED: {
      display_name: 'Partiellement livrée',
      color: '#e55039',
      color_class: 'issue',
      icon: faCheck,
      style_checkbox: 'tw-bg-yellow-500',
      style: STATUS_ENUM.WARN,
    },
    DELIVERED: {
      display_name: 'Livrée',
      color: '#079992',
      color_class: 'ok',
      icon: faCheck,
      style_checkbox: 'tw-bg-green-500',
      style: STATUS_ENUM.POSITIVE,
    },
    CANCELED: {
      display_name: 'Non livrée',
      color: '#e55039',
      color_class: 'issue',
      icon: faTimes,
      style_checkbox: 'tw-bg-red-500',
      style: STATUS_ENUM.NEGATIVE,
    },
  },
};
